//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
    },
  },
  data() {
    return {
      noBirthstonesGroups: ['PALPHOTO','PALNAME','RING_NF','EARRING_NF','PENDANT_NF','BRACELET_NF'],
    }
  },
}
